import {Link} from "react-router-dom";
import React from 'react';
import { connect } from 'react-redux';
import { setInfo } from '../redux/actionList';
import withRouterCompat from "../objects/CommonUse/with_router_compat";
import LinkTab from '../components/shared-components/link_tab';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
//import {InputCompletedContext} from '../objects/Context/input_completed_context';
import tooltipMoneyBuilderText from "./Text/tooltip_money_builder_text";

import GameChoicePictures from "../components/game-views/game_choice_pictures";
import ConductorDashboard from "../components/moneyBuilder/conductor_dashboard";
import InvestmentMainDisplay from "../components/moneyBuilder/investment_main_display";
import TransactionHistoryMain from "../components/moneyBuilder/transaction_history_main";
import SetupSavings from "../components/moneyBuilder/setup_savings";
import CommentModal from '../components/shared-components/comment_modal';
import WaitTimeSpinner from "../components/shared-components/wait_time_spinner";
import Footer from "./footer";
import createInvestmentSummaryArr from "./Objects/create_investment_summary_arr";

import selectInvestMaster from "./Objects/select_invest_master";
import createShortNameArr from "./Objects/create_short_name_arr";
import investmentsGetCurrentPrice from "./Objects/investments_get_current_price";

import { setHeadersForFetch } from '../objects/CommonUse/set_headers_for_fetch';
import {buildUrl } from '../objects/CommonUse/build_URL';
import ConfigFile from "../datasets/config_file";
import Config from '../config';
import retirement401KInfo from "../components/moneyBuilder/savings/datasets/retirement_401k_info";
import updateSessionTokenStorage from "./Objects/update_session_token_storage";
import AchievementsDataset from "../components/game-views/datasets/achievements_dataset";
import checkForAchievements from "../objects/CommonUse/check_for_achievements";
import CelebrationModal from "../components/shared-components/celebration_modal";
import getTrophyInfo from "../objects/CommonUse/get_trophy_info";
import determineCelebrationText from "../objects/CommonUse/determine_celebration_text";
import changeFirstCharToUpperCase from "../objects/CommonUse/change_first_char_to_upper_case";
import selectInvestMasterForBuyTrans from "../objects/CommonUse/select_invest_master_for_buyTrans";
import WarningModal from "../components/shared-components/warning_modal";

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
    gameData: state.gameData,
    timeWizardInfo: state.timeWizardInfo,
    pictureInfo: state.pictureInfo,
    retirementPriceArr: state.retirementPriceArr,
    creditReport: state.creditReport,
    summaryInvestment: state.summaryInvestment
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class MoneyBuilder extends React.Component {
    constructor(props) {
        super(props);
                       
     this.openCommentModal = this.openCommentModal.bind(this);
     this.closeCommentModal = this.closeCommentModal.bind(this);
     this.clickIntercept = this.clickIntercept.bind(this);
     this.state = {
        inputArr: [
            {
                completed: false,
                selected: false,
            },
            {
                completed: false,
                selected: false,           
            },
            {
                completed: false,
                selected: false,
            },
            {
                completed: false,
                selected: false,
            },
            {
                completed: false,
                selected: false,
            },
            {
                completed: false,
                selected: false,
            },
        ],
        investmentCategory: "",
        commentIcon: "./assets/ContactUs/pencilPaper.png",
        commentModalOpen: false,
        fromProcessName: "MoneyBuilder",
        screenSize: sessionStorage.getItem("GameScreenSize"),
        headers: setHeadersForFetch(),
        environment: Config.dataURL.currentEnv,
        subProcess: "MoneyBuilderPage",
        investmentsLoaded: false,
        savingsLoaded: false,
        friendsLoaded: false,
        pendingNavigation: false,
        celebrationModal: false,
        rerender: false,
        hasUnconfirmedChanged: false,
        displayWarningModal: false,
        investTypeArr: [ 
                {investType: "bond"}, {investType: "index"},
                {investType: "mutualfund"}, {investType: "stock"},],
        moneyBuildInfo: {
            gameData: "",
            summaryBuyArr: "",
            transactionDetailArr: "",
            investmentMasterData: "",
            gameInvestments: [],
            pictureInfo: "",
            totalNbrGameMonths: "",
            savingsInfo: {},
            interestRateArr: [],
        }
    };
    switch(props.selected) {
        case "conductorDashboard":
            this.inputSelected(0);
            break;
        case "bankAccounts":
            this.inputSelected(1);
             break;
        case "retirementAccount":
            this.inputSelected(2);
            break;
        case "investmentSelect":
            this.inputSelected(3);
            break;
         case "transactionHistory":
            this.inputSelected(4);
            break;
        case "returnGameboard":
            this.inputSelected(5);
            break;
        default:
            break;
    }
    this.gameInvestments = [];
    this.investmentMasterData = [];
    this.investmentMonthlyData = [];
    this.summaryBuyArr = [];
    this.transactionDetailArr = [];
    this.totalNbrGameMonths = ConfigFile.gameStartItems.totalNbrGameMonths;
};

    selectInvestType(investType){
        this.investType = investType;
        const summaryTranObj = this.summaryBuyArr.find(elem => elem.investType === this.investType);
        if (summaryTranObj){
            this.selectSummaryTranArr = summaryTranObj.buyTransArr;
        }else{
            this.selectSummaryTranArr = [];
        }
        this.selectBuyTranArr = [];
        for (let i=0; i<this.transactionDetailArr.length; i++){
            const tranDetail = this.transactionDetailArr[i];
            if (tranDetail.investType === this.investType){
                this.selectBuyTranArr.push(tranDetail);
            }
        }
        this.selectInvestmentMasterArr = [];
        for (let i=0; i<this.investmentMasterData.length; i++){
            const investMaster = this.investmentMasterData[i];
            if (investMaster.investmentType === this.investType){
                this.selectInvestmentMasterArr.push(investMaster);
            }
        }
        this.setState({rerender: !this.state.rerender});
    }

    setBuyOrSell(buttonText){
        this.tranType = buttonText;
        this.setState({rerender: !this.state.rerender});
    }

    onNavigate = (path) => {
        const { navigate, location } = this.props;
        // Corrected pathname comparison
        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };

      
    render(){
        if (this.state.investmentsLoaded === true && this.state.savingsLoaded === true &&
            this.state.friendsLoaded === true){
            this.allDataLoaded = true;
        }
        if (this.props.selected === "bankAccounts"){
            this.savingsClass = "bank";
        }
        if (this.props.selected === "retirementAccount"){
            this.savingsClass = "retirement";
        }
    return <>
        <span className="container">
            <span className="row w-100 mx-0">
                <div className="col-sm-2 mt-4">
                        <div>
                            <GameChoicePictures 
                                pictureInfo={this.state.moneyBuildInfo.pictureInfo}
                            />
                        </div>
                </div>

                {!this.allDataLoaded ? 
                    <div className="col-sm-8 mb-5 input-page-base-card">
                        <WaitTimeSpinner/>
                    </div>
                :
               
                    <div>
                        <img src={this.state.commentIcon} 
                                className="moneyBuilder-comment-icon-position comment-img cursor-is-pointer"
                                alt="comment"
                                onClick={this.openCommentModal}/>
                        
                    </div>
                }
        
                {this.state.commentModalOpen ?
                    <CommentModal modalOpen={this.state.commentModalOpen} 
                        onClose={() => this.closeCommentModal()}
                        gamePart={this.state.fromProcessName}
                        processName={this.props.selected}
                        gameInfo = {() => this.getMoneyBuildInfo()}
                        processError = {(errorObj) => this.processErrorReturn(errorObj)}
                    />
                :
                    null
                }
                {this.props.selected === "conductorDashboard" && this.allDataLoaded === true ?
                    <ConductorDashboard
                        level = {this.moneyBuildLevel}
                        onOpen ={()=> this.inputSelected(0)}
                        onClose={()=>this.backToGameBoard()}
                        moneyBuildInfo = {() => this.getMoneyBuildInfo()} 
                        onNavigate={(path) => this.onNavigate(path)}
                        setMoneyBuildInfo = {(value, propertyName) => this.setMoneyBuildInfo(value, propertyName)}
                        processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                :
                    null
                }
                {(this.props.selected === "bankAccounts" || this.props.selected === "retirementAccount")
                  && this.allDataLoaded === true ?
                     <SetupSavings 
                        savingsClass = {this.savingsClass}
                        currentMonthNbr = {this.currentGameMonth}
                        onClose={(returnVal) => this.closeModal(returnVal)}
                        moneyBuildInfo = {() => this.getMoneyBuildInfo()} 
                        reloadSavings = {() => this.loadSavings("bank")}
                        checkGameAchievements = {(moneyBuilderType) => this.checkGameAchievements(moneyBuilderType)}
                        setMoneyBuildInfo = {(value, propertyName) => this.setMoneyBuildInfo(value, propertyName)}
                        onChangesNotConfirmed = {(newValue) => this.handleUnconfirmedChanges(newValue)}
                        processError = {(errorObj) => this.processErrorReturn(errorObj)}
                    />
                :
                    null
                }
                {this.props.selected === "investmentSelect"  && this.allDataLoaded === true ?
                    <InvestmentMainDisplay
                        investType = {this.investType}
                        tranType = {this.tranType}
                        onOpen ={()=> this.inputSelected(0)}
                        onClose={()=>this.backToGameBoard()}
                        currentGameMonth={this.currentGameMonth}
                        summaryTranArr = {this.selectSummaryTranArr}
                        buyTranArr = {this.selectBuyTranArr} 
                        investmentMasterArr = {this.selectInvestmentMasterArr}
                        setBuyOrSell = {(buttonText) => this.setBuyOrSell(buttonText)}
                        moneyBuildInfo = {() => this.getMoneyBuildInfo()} 
                        inputSelected = {() => this.handleClick(0)}
                        selectInvestType = {(investType) => this.selectInvestType(investType)}
                        reloadGameInvestments = {() => this.loadGameInvestments()}
                        loadInvestmentMaster = {() => this.loadInvestmentMaster()}
                        setMoneyBuildInfo = {(value, propertyName) => this.setMoneyBuildInfo(value, propertyName)}
                        processError = {(errorObj) => this.processErrorReturn(errorObj)}
                    /> 
                : <span/>}

                {this.props.selected === "transactionHistory" && this.allDataLoaded === true ?
                    <TransactionHistoryMain
                        moneyBuildInfo = {() => this.getMoneyBuildInfo()} 
                        inputSelected = {() => this.handleClick(5)}
                        processError = {(errorObj) => this.processErrorReturn(errorObj)}
                    />
                : <span/>}

                {this.state.celebrationModal   ? 
                    <CelebrationModal
                        isOpen={this.state.celebrationModal}
                        onClose={() => this.closeCelebrationModal()}                        
                        type={this.achievementType}
                        title={this.achievementTitle}
                        description={this.additionalText}
                        imgSrc={this.imgSrc}
                        trophyID={this.achievementID}
                    />
                :
                    null
                }

                {this.state.displayWarningModal  ?
                    <WarningModal
                        show={this.state.displayWarningModal}
                        warningTitle={this.warningTitle}
                        warningMsg={this.warningMsg}
                        onClose={(btnClicked) => this.closeWarningModal(btnClicked)}
                    />
                :
                    null
                }
   
                <div className="col-sm-2"> 
                    <Link to="/conductor-dashboard" onClick={(e) => this.clickIntercept(e, 0, "/conductor-dashboard")}>
                        <LinkTab inputArr={this.state.inputArr[0]} name="Conductor's Dashboard" validToComplete="true"
                         fiveTabs={true}/>
                    </Link>
                                
                    <Link to="/bank-accounts" onClick={(e) => this.clickIntercept(e, 1, "/bank-accounts")}>
                        <LinkTab inputArr={this.state.inputArr[1]} name="Bank Accounts" validToComplete="true"
                        fiveTabs={true}   />
                    </Link>

                    {this.moneyBuildLevel >= "2"  ?           
                        <Link to="/retirement-account" onClick={(e) => this.clickIntercept(e, 2, "/retirement-account")}>
                            <LinkTab inputArr={this.state.inputArr[2]} name="Retirement Accounts 401(k)" 
                                fiveTabs={true} validToComplete="true"  />
                        </Link>
                    :
                        <span
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={tooltipMoneyBuilderText}>
                            <LinkTab inputArr={this.state.inputArr[2]} 
                                name="Retirement Accounts 401(k)" 
                            />
                            <Tooltip id="my-tooltip" place="top" />
                        </span>
                    }
                    
                     {this.moneyBuildLevel >= "3"  ?           
                        <Link to="/investment-select" onClick={(e) => this.clickIntercept(e, 3, "/investment-select")}>
                            <LinkTab inputArr={this.state.inputArr[3]} name="Investments" validToComplete="true"
                                 fiveTabs={true}/>
                        </Link>
                    :
                        <span
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={tooltipMoneyBuilderText}>
                            <LinkTab
                                inputArr={this.state.inputArr[3]}
                                name="Investments"
                                />
                            <Tooltip id="my-tooltip" place="top" />
                        </span>

                    }

                    <Link to="/transaction-history" onClick={(e) => this.clickIntercept(e, 4, "/transaction-history")}>
                        <LinkTab inputArr={this.state.inputArr[4]} name="Transaction History" validToComplete="true"
                             fiveTabs={true}/>
                    </Link>

                    <Link to="/return-gameboard" onClick={(e) => this.clickIntercept(e, 5, "/return-gameboard")}>
                        <LinkTab inputArr={this.state.inputArr[5]} name="Return to GameBoard" validToComplete="true"
                            fiveTabs={true}/>
                    </Link>
                    {(this.state.screenSize === "zoom") &&
                        <Footer 
                            screenSize={this.state.screenSize}
                        />
                    }
                </div>  
            </span>
        </span>             
    </>
}

    componentDidMount(){
        this._isMounted = true;
        console.log("moneyBuilder componentDidMount");         
        updateSessionTokenStorage("moneyBuilderPassThru");
        const gameData = this.props.gameData;
        const unlockedFeatures = gameData.unlockedFeatures;
        const moneyBuildFeature = unlockedFeatures.find(elem => elem.featureName === "moneyBuilder");
        if (moneyBuildFeature){
            this.moneyBuildLevel = moneyBuildFeature.level;
        }
        this.setMoneyBuildInfo(gameData, "gameData");
        this.gameData = gameData;
        this.gameID = gameData._id;
        const timeWizardInfo = this.props.timeWizardInfo;
        if (timeWizardInfo.status && timeWizardInfo.status === "active"){
            this.totalNbrGameMonths = (+timeWizardInfo.gameNbrYears * 12).toFixed(0);
        }
        console.log("totalGameMonths: ", this.totalNbrGameMonths)
        this.setMoneyBuildInfo(this.totalNbrGameMonths, "totalNbrGameMonths");
        this.currentGameMonth = this.totalNbrGameMonths - +gameData.gameNbrMonths;
        const pictureInfo = this.props.pictureInfo;
        this.setMoneyBuildInfo(pictureInfo, "pictureInfo"); 
        this.tranType = "buy";
        const feature = gameData.unlockedFeatures.find(elem => elem.featureName === "moneyBuilder");
        let savingsParm = "bank";
        if (feature && feature.level >= "2"){
            savingsParm = "retirement";
        }
        this.loadSavings(savingsParm);
        if (feature && feature.level >= "3"){
            this.loadInvestmentMaster();
        }else{
            this.setState({investmentsLoaded: true});
        }
        this.loadFriends();
    }

    inputSelected = (inputID) => {
        let inputArr = this.state.inputArr;
        for (const input of inputArr) {
            input.selected = false;
        }
        inputArr[inputID].selected = true;
        if (this._isMounted === true){
            this.setState({inputArr: inputArr});  
        }
        
    };
     
    inputCompleted = (inputID) => {
        let inputArr = this.state.inputArr;
        inputArr[inputID].completed = true;
        if (this._isMounted === true){
            this.setState({inputArr: inputArr}); 
        }
    };
    
    displayCelebrationModal(){
        this.achievementType = "trophy";
        this.achievementID = this.achievementArr[0].achievementID;
        this.achievementTitle = this.achievementArr[0].achievementTitle;
        const achievementCode = this.achievementID.substring(0,1);
        const medalTypeObj = getTrophyInfo(achievementCode);
        this.imgSrc = medalTypeObj.imgSrc;
        const medalType = medalTypeObj.medalType;  
        this.additionalText = determineCelebrationText(medalType, this.achievementID); 
        this.setState({celebrationModal: true});   
    }

    closeCelebrationModal(){
        this.setState({celebrationModal: false});
        this.achievementArr.splice(0,1);
        if (this.achievementArr.length > 0){
            this.displayCelebrationModal();
        }
    }

    backToGameBoard(){
        this.onNavigate("game-board");
    }

    openCommentModal(){
        this.setState({commentModalOpen: true});
    }

    closeCommentModal(){
        this.setState({commentModalOpen: false});
    }

    handleClick = index => {
        this.inputSelected(index);
    }
    
    handleUnconfirmedChanges(newValue){
        this.setState({hasUnconfirmedChanges: newValue});
    }

    clickIntercept(e, index, destination) {
        if (this.state.hasUnconfirmedChanges === true) {
            e.preventDefault(); // block the Link's default navigation
            this.setState({
                pendingDestination: destination,
                pendingIndex: index
            });
                this.openWarningModal();
        }else{
            this.inputSelected(index);
        }
    // else: no unconfirmed changes, let the Link navigate as normal
    }

    openWarningModal(){
        this.warningTitle = "Wait - Don't Lose Your Work";
        let changeType = "";
        switch (this.props.selected){
            case "bankAccounts":
                changeType = "bank saving accounts";
                break;
            case "retirementAccount":
                changeType = "retirement saving accounts";
                break;
            default:
                break;
        }
        this.warningMsg = "The changes you have made to your " + changeType +
            " have not been saved.  If you wish to save the changes, click the " +
            " 'GoBack' button and then confirm the changes.";
        this.setState({displayWarningModal: true});
    }

    closeWarningModal(btnSelected){
        if (btnSelected === 'discard') {
            this.setState({displayWarningModal: false, hasUnconfirmedChanges: false});
            this.inputSelected(this.state.pendingIndex);
            const endChar = this.state.pendingDestination.length;
            const pendingDestination = this.state.pendingDestination.substring(1,endChar);
            this.onNavigate(pendingDestination);
        } else {
            // 'goBack' — just close the modal, nothing else to do
            this.setState({ displayWarningModal: false });
        }
    }
  
    getMoneyBuildInfo()
    {
        return this.state.moneyBuildInfo;
    }

    setMoneyBuildInfo(value, propertyName = null)
    {
        if (propertyName)
        {
            let moneyBuildInfo = this.state.moneyBuildInfo;
            moneyBuildInfo[propertyName] = value;
            if (this._isMounted === true){
                this.setState({moneyBuildInfo: moneyBuildInfo});
            }
        }
        else this.setState({moneyBuildInfo: value});
    }

    checkGameAchievements(moneyBuilderType){
        let slctDatanameArr = [];
        if (moneyBuilderType === "savings"){
             slctDatanameArr = ["bankSavings", "retirementSavings"];
        }
        if (moneyBuilderType === "investments"){
             slctDatanameArr = ["investments", "investmentMix"];
        }
        let achievementInfo = AchievementsDataset;
        let newAchievementArr = [];
        let achievementInfoArr = [];
        for (let i=0; i<achievementInfo.length; i++){
            const criteriaArr = achievementInfo[i].criteriaArr;
            const monthCriteria = achievementInfo[i].monthCriteria;
            for (let j=0; j<criteriaArr.length; j++){
                const dataName = criteriaArr[j].dataName;
                if (slctDatanameArr.includes(dataName) && monthCriteria.monthType === "none"){
                    const achievementCheck = this.state.moneyBuildInfo.gameData.achievementArr.find(
                        elem => elem.achievementID === achievementInfo[i].achievementID );
                    if (achievementCheck){
                        // this achievement has already been earned and updated
                    }else{
                       achievementInfoArr.push(achievementInfo[i]);
                    }
                }
            }
        }
        // need to add notifications to this process!!!!
        if (achievementInfoArr.length > 0){
            // update the achievementArr in the games-collection
            const nbrMonthsPlayed = this.totalNbrGameMonths - this.state.moneyBuildInfo.gameData.gameNbrMonths;
            let monthsPerTurn = 1;
            if (this.state.moneyBuildInfo.timeWizard && this.state.moneyBuildInfo.monthsPerTurn){
                monthsPerTurn = this.state.moneyBuildInfo.timeWizard.monthsPerTurn;
            }
            const slctdInvestmentMasterData = selectInvestMasterForBuyTrans(this.state.moneyBuildInfo.summaryBuyArr,
                this.investmentMasterData );
            newAchievementArr = checkForAchievements(this.state.moneyBuildInfo.gameData,
                this.state.moneyBuildInfo.savingsInfo, {}, this.summaryInvestment, slctdInvestmentMasterData,
                nbrMonthsPlayed, 0, monthsPerTurn, [], this.props.timeWizardInfo,
                "moneyBuilder", achievementInfoArr )
           
            
            if (newAchievementArr.length > 0){
                sessionStorage.setItem("newAwardEarned", true);
                this.setMoneyBuildInfo(this.state.moneyBuildInfo.gameData, "gameData");
                this.updateGameAchievementArr();
                this.achievementArr = newAchievementArr;
                this.displayCelebrationModal();
            }
        }
    }

    loadSavings(savingsParm) {
        const funcName = "loadSavings";
        const urlParm = "?gameID=" + this.gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.savings = output.body;
                        this.setMoneyBuildInfo(this.savings, "savingsInfo");
                        this.getRetirementSavingPrices(savingsParm);
                        this.props.setInfoRedux(this.savings, "savingsInfo");
                    }else{
                        if (statusCode === 250){
                            // there is no savings for this player;
                            this.getRetirementSavingPrices(savingsParm);
                            this.setState({savingsLoaded: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
            });
    }

    async getRetirementSavingPrices(savingsParm){
        const retirementPriceArr = this.props.retirementPriceArr;
        if (savingsParm === "retirement" || retirementPriceArr.length === 0){
            let retirementArr = retirement401KInfo;
            this.shortNameArr = [];
            for (let i=0; i<retirementArr.length; i++){
                this.shortNameArr.push(retirementArr[i].shortName);
            }
            this.startMonthNbr = this.currentGameMonth;
            const totalGameMonths = ConfigFile.gameStartItems.totalNbrGameMonths;
            this.endMonthNbr = +totalGameMonths;
            await this.loadInvestmentMonthly();
            let currentPriceArr = [];
            for (let i=0; i<this.monthlyPricingData.length; i++){
                let investmentMonthlyData = this.monthlyPricingData[i];
                const currentPriceObj = {retirementType: investmentMonthlyData.investShortName, 
                    monthNbr: investmentMonthlyData.monthNbr,
                    currentPrice: investmentMonthlyData.closingPrice }
                currentPriceArr.push(currentPriceObj);
            }
            this.props.setInfoRedux(currentPriceArr, "retirementPriceArr");
        }
        this.setState({savingsLoaded: true});
    }
    
    loadInvestmentMaster(){
        const funcName = "investmentMasterList";
        const urlParm = "?queryType=all";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
                {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        const investmentMasterData = output.body;
                        if (this._isMounted === true){
                            this.setState({investmentMasterLoaded: true});
                            this.getInvestmentMonthlyForAllInvestments(investmentMasterData);
                        }
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: urlParm};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }

    async getInvestmentMonthlyForAllInvestments(investmentMasterData){
        investmentMasterData.sort((a, b) => (a.investShortName > b.investShortName) ? 1 : -1);
        const currentGameMonth = +this.totalNbrGameMonths - +this.gameData.gameNbrMonths;
        console.log("current game month: ", currentGameMonth);
        this.investmentMasterData = selectInvestMaster(investmentMasterData, currentGameMonth);
        for (let i=0; i<this.investmentMasterData.length; i++){
            let investClass = this.investmentMasterData[i].classification;
            if (this.investmentMasterData[i].investmentClass !== "bond" &&
                this.investmentMasterData[i].investmentClass !== "stock" ){
                investClass = this.investmentMasterData[i].investmentClass;
            }else{
                investClass = changeFirstCharToUpperCase(investClass);
            }
            this.investmentMasterData[i] = {...this.investmentMasterData[i], investClass: investClass};
        }
        this.shortNameArr = createShortNameArr(this.gameInvestments, this.investmentMasterData);
        this.setMoneyBuildInfo(this.investmentMasterData, "investmentMasterData");
        this.startMonthNbr = this.currentGameMonth;
        this.endMonthNbr = this.currentGameMonth;
        await this.loadInvestmentMonthly();
        this.investmentMonthlyData = this.monthlyPricingData;
        this.loadGameInvestments();
        if (this._isMounted) {
            this.setState({ investmentMonthlyLoaded: true });
        }
    }

    async loadInvestmentMonthly() {
        const funcName = "investmentMonthlySelect";
        this.gameInvestBehavior = "1";

        const shortNameList = this.shortNameArr.join(',');
        const urlParm = "?investShortName=" + shortNameList +
                        "&behavior=" + this.gameInvestBehavior +
                        "&startMonthNbr=" + this.startMonthNbr +
                        "&endMonthNbr=" + this.endMonthNbr;

        const uri = buildUrl(this.state.environment, funcName, urlParm);

        try {
            const response = await fetch(uri, {
                method: 'GET',
                headers: this.state.headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const output = JSON.parse(data);
            const statusCode = output.statusCode;

            if (statusCode === 200) {
                this.monthlyPricingData = output.body;
            } else {
                const errorObj = {
                    function: funcName,
                    subProcess: this.state.subProcess,
                    status: statusCode,
                    message: output.body.message,
                    errorObject: urlParm
                };
                this.processErrorReturn(errorObj);
            }

        } catch (error) {
            console.error("Fetch error in loadInvestmentMonthly:", error);
            const errorObj = {
                function: funcName,
                subProcess: this.state.subProcess,
                status: "network-error",
                message: error.message,
                errorObject: urlParm
            };
            this.processErrorReturn(errorObj);
        }
    }

    loadGameInvestments() {
        const funcName = "loadGameInvestments";
        const urlParm = "?gameID=" + this.gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.gameInvestments = output.body;
                        this.props.setInfoRedux(this.gameInvestments, "gameInvestments");
                        this.buildInvestmentFiles();
                        this.setMoneyBuildInfo(this.gameInvestments, "gameInvestments");
                        if (this._isMounted === true){
                            this.setState({gameInvestmentsLoaded: true});
                        }
                    }else{
                        if (statusCode === 250){
                            this.investmentTransactionData = this.state.investTypeArr;
                            this.gameInvestments = [];
                            this.buildInvestmentFiles();
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message, errorObject: urlParm};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
            });
    }

    buildInvestmentFiles(){
        const investTables = investmentsGetCurrentPrice(this.investmentMonthlyData, this.investmentMasterData,
            this.gameInvestments);
        this.transactionDetailArr = investTables.transactionDetailArr;
        this.summaryBuyArr = investTables.summaryBuyArr;
        this.totalBuyArr = investTables.totalBuyArr;
        const updatedGameInvestments = investTables.updatedGameInvestments;
        let gameInvestmentsUpdated = false;
        for (let i=0; i<updatedGameInvestments.length; i++){
            const investType = updatedGameInvestments[i].investType;
            const gameInvIndx = this.gameInvestments.findIndex(elem => elem.investType === investType);
            if (gameInvIndx !== -1){
                gameInvestmentsUpdated = true;
                this.updateGameTransactions(updatedGameInvestments[i]);
                this.gameInvestments[gameInvIndx] = updatedGameInvestments[i];
            }else{
                const message = "UpdatedGameInvestment not found on GameInvestments?"
                const errorObj={function: "general", subProcess: this.state.subProcess, 
                    status: 999, message: message, errorObject: updatedGameInvestments[i],
                    silentAlert: true};
                this.processErrorReturn(errorObj);
            }
        }
        if (gameInvestmentsUpdated === true){
            this.props.setInfoRedux(this.gameInvestments, "gameInvestments");
        }
        let currentPriceArr = [];
        for (let i=0; i<this.investmentMonthlyData.length; i++){
            const monthlyData = this.investmentMonthlyData[i];
            const currentPriceObj = 
                {investShortName: monthlyData.investShortName, currentPrice: monthlyData.closingPrice};
            currentPriceArr.push(currentPriceObj);
        }
        let summaryValueArr = createInvestmentSummaryArr(this.gameInvestments, this.investmentMasterData,
                currentPriceArr, this.gameData.startGameDate, 
                this.gameData.currentGameDate
            )
       
        this.props.setInfoRedux( summaryValueArr, "summaryInvestment");
        this.setMoneyBuildInfo(this.transactionDetailArr, "transactionDetailArr");
        this.setMoneyBuildInfo(this.summaryBuyArr, "summaryBuyArr");
        this.summaryInvestment = summaryValueArr;
        const allInvestmentAmt = this.summaryInvestment.find(elem => elem.investType === "all").currentValue;
        if (allInvestmentAmt !== 0){
            this.checkGameAchievements("investments");
        }
        this.setState({investmentsLoaded: true});
    }

    updateGameTransactions(updatedGameInvestObj){
        const investType = updatedGameInvestObj.investType;
        const funcName = "updateGameInvestments";
        const urlParm = "?gameID=" + this.state.moneyBuildInfo.gameData._id + 
            "&investType=" + investType;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(updatedGameInvestObj)
            })
            .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (output.statusCode === 200){ 
                    //  update of gameTransactions was successful
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.gameInvestmentObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
    }

    loadFriends() {
        const funcName = "loadFriends";
        let friendArr = [];
        const friendList = this.gameData.friendList;
        for (let i = 0; i < friendList.length; i++) {
            let friendName = friendList[i].name;
            friendArr.push(friendName);
        }
        const friendParm = friendArr.join(',');
        const urlParm = "?friendArr=" + friendParm;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.buildFriendInfoArr(output.body);
                        this.setState({friendsLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message}
                        this.processErrorReturn(errorObj);
                    }
                });
            });
    }
        
    buildFriendInfoArr(friendData) {
        let friendArr = [];
        let startIdx = friendData.length - 1;
        for (let i = startIdx; i >= 0; i--) {
            let friendImgURL = './assets/friends/' + friendData[i].friendImg
            let friendObj = {
                friendName: friendData[i].friendName, friendImgURL: friendImgURL,
                weightedOdds: friendData[i].weightedOdds
            };
            friendArr.push(friendObj);
        }
        this.setMoneyBuildInfo(friendArr, "friendInfo");
    }
    
    updateGameAchievementArr(){
        const funcName = "updateAchievementArr";
        let bodyObj = {achievementArr: this.state.moneyBuildInfo.gameData.achievementArr};
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'PUT', headers: this.state.headers, 
            body: JSON.stringify(bodyObj)})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        // update of the achievementArr in gameData was successful
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, 
                            errorObject: this.moneyBuildInfo.savingsInfo};
                        this.processErrorReturn(errorObj);
                    }
                });
                }
            });
    }

    processErrorReturn(errorObj){
        this.addRecordToLogfile(errorObj);
        if (!errorObj.silentAlert || errorObj.silentAlert === false){
            alert ("Uh oh!  Something unexpected has occurred " +
                "error has been logged and will be addressed. " +
                "For now click OK, then return to the process " +
                "where you were and try again.");
            this.onNavigate("");
        }
    }

    addRecordToLogfile(errorObj){
        const headers=setHeadersForFetch();  
        if (errorObj.status === 250){
            errorObj.message = "No record found";
        }
        const logFileBody =  {
            mainProcess: "MoneyBuilder",
            subProcess: errorObj.subProcess,
            function: errorObj.function,
            status: errorObj.status,
            message: errorObj.message,
            errorObj: errorObj.errorObject
        };
        console.log("logFileBody is: ", logFileBody)
        const urlParm = "";
        const uri = buildUrl(this.state.environment, "saveLogFile", urlParm);
        fetch (uri,  
            {method:'POST',
                headers: headers,
                body: JSON.stringify(logFileBody)
            })
                .then(response => {
                    if (response.ok){
                        response.json().then(data => {
                            const output = JSON.parse(data);
                            const statusCode = output.statusCode;
                            if (statusCode === 200){
                                console.log("logfile create was successful");
                            }else{
                                console.log("Response from save log file not valid!" +
                                    " status is: ", output.statusCode,
                                    " message is: ", output.body);
                                alert ("Response from save log file not valid!"  )
                                
                            }
                    });
            }
        });
    }

}
export default  connect(mapStateToProps, mapDispatchToProps) (withRouterCompat(MoneyBuilder));